import {HttpInterceptorFn} from '@angular/common/http';
import {environment} from '../../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const urlsToExclude = [
    'excludedUrl'
  ];
  const apiUrl = environment.apiDomain + '/api/';
  const apiRequest = req.clone({url: apiUrl + req.url});
  let apiFromDomainRequest = req.clone({url: environment.apiDomain + '/' + req.url});
  // Function check if url should be escluded according to urlsToExclude list
  const isValidRequestForInterceptor = (requestUrl: string): boolean => {
    if (requestUrl.endsWith('.pdf')) {
      apiFromDomainRequest = req.clone({url: environment.fileDomain + '/' + req.url});
      return false;
    }
    for (const address of urlsToExclude) {
      if (new RegExp(address).test(requestUrl)) {
        apiFromDomainRequest = req.clone({url: environment.apiDomain + '/' + req.url});
        return false;
      }
    }
    return true;
  }
  if (isValidRequestForInterceptor(req.url)) {
    return next(apiRequest);
  }
  return next(apiFromDomainRequest);
};
